import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from './environments/environment';

export const functionsKeyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.api.baseUrl)) {
    return next(req);
  }

  const modifiedReq = req.clone({
    setHeaders: {
      'x-functions-key': environment.api.apiKey || ''
    }
  });

  return next(modifiedReq);
};